<template>
  <growth-contact-widget
    v-if="catchEmailOnCheckoutStart"
    email-only
    origin="course"
    @submit="navigateTo(session.enrolRoute)"
  >
    <app-button v-bind="buttonBinding" data-cy-enrol @click="onCheckoutStart()">
      {{ label ?? $t("course.page.next_session_enrolment.primary_cta_label") }}
    </app-button>
  </growth-contact-widget>

  <app-button
    v-else
    data-cy-enrol
    no-follow
    v-bind="buttonBinding"
    :to="session.enrolRoute"
    @click="onCheckoutStart()"
  >
    {{ label ?? $t("course.page.next_session_enrolment.primary_cta_label") }}
  </app-button>
</template>

<script lang="ts" setup>
import type { I18nMessage } from "@pollen/core/model/i18n.model";
import type {
  ButtonColor,
  ButtonSize,
  ButtonVariant,
} from "@pollen/ui-library";

import type { CourseSessionView } from "~/business-areas/course-session/course-session.model";

const properties = defineProps<{
  session: CourseSessionView;
  size?: ButtonSize;
  color?: ButtonColor;
  variant?: ButtonVariant;
  block?: boolean;
  label?: I18nMessage;
}>();

const { isAuthenticated } = useCurrentUser();
const { state } = useGrowthContact();

const catchEmailOnCheckoutStart = computed(
  () => !isAuthenticated.value && !state.value?.email,
);

const { $analytics } = useNuxtApp();

const onCheckoutStart = () => $analytics.track("checkout_started");

const buttonBinding = computed(() => {
  return {
    size: properties.size,
    color: properties.color,
    variant: properties.variant,
    block: properties.block,
  };
});
</script>
